import __request__ from "routing/request";
export function updateConfig(config2, requestOptions) {
  return __request__("PUT", "/system/messageprocessors/config", config2, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function config(requestOptions) {
  return __request__("GET", "/system/messageprocessors/config", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
